import isEqual from 'lodash/isEqual';
import type {AnyAction} from 'redux';
import {combineReducers} from 'redux';

import type {UserProfile} from '@mattermost/types/users';

import {DiscoveryTypes} from 'mattermost-redux/action_types';
import { DiscoveryState } from '@mattermost/types/discovery'; 


function popularBots(state: DiscoveryState['popularBots'] = [], action: AnyAction) {
    switch (action.type) {
        case DiscoveryTypes.RECEIVED_POPULAR:
            // console.log('Action received: RECEIVED_POPULAR pre-state:', state)
            // console.log('Action received: RECEIVED_POPULAR:', action.data)
            const users: UserProfile[] = action.data || [];
            return [
                ...users,
            ];
    
        default:
            return state;
        }    
}

function featuredBots(state: DiscoveryState['featuredBots'] = [], action: AnyAction) {
    switch (action.type) {
        case DiscoveryTypes.RECEIVED_FEATURED:
            // console.log('Action received: RECEIVED_FEATURED pre-state:', state)
            // console.log('Action received: RECEIVED_FEATURED:', action.data)
            const users: UserProfile[] = action.data || [];
            return [
                ...users,
            ];
    
        default:
            return state;
        }
}

function newBots(state: DiscoveryState['newBots'] = [], action: AnyAction) {
    switch (action.type) {
        case DiscoveryTypes.RECEIVED_NEW:
            // console.log('Action received: RECEIVED_NEW pre-state:', state)
            // console.log('Action received: RECEIVED_NEW:', action.data)
            const users: UserProfile[] = action.data || [];
            return [
                ...users,
            ];
    
        default:
            return state;
        }
}

export default combineReducers({
    popularBots,
    featuredBots,
    newBots,
});
